import React from "react";
import { Heart } from "lucide-react";
import { Link } from "react-router-dom";
import { fileUrl } from "../lib/api";

const tierClass = {
  premium: "tier-premium",
  gold: "tier-gold",
  standard: "tier-standard",
};

const AngelCard = ({ angel, favorited, onToggleFav }) => {
  const photo = angel.main_photo_path ? fileUrl(angel.main_photo_path) : null;

  return (
    <div
      data-testid={`angel-card-${angel.angel_id}`}
      className={`angel-card relative rounded-xl overflow-hidden bg-[#1A2118] ${tierClass[angel.tier] || ""}`}
    >
      <Link to={`/angel/${angel.angel_id}`} className="block relative aspect-[9/16]">
        {photo ? (
          <img src={photo} alt={angel.artistic_name} className="w-full h-full object-cover no-save" loading="lazy"
               draggable={false} onContextMenu={(e) => e.preventDefault()} />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-[#FAF9F6]/60 font-serif text-3xl bg-[#1A2118]">
            {angel.artistic_name?.[0] || "A"}
          </div>
        )}
        <div className="cherub-watermark absolute inset-0" />

        {/* Top indicators */}
        {angel.is_available && (
          <div data-testid={`available-dot-${angel.angel_id}`} className="absolute top-3 left-3 w-3 h-3 rounded-full available-dot" />
        )}
        {angel.tier === "premium" && (
          <div className="absolute top-3 right-3 px-2 py-0.5 bg-[#D4AF37] text-[#1A2118] text-[10px] tracking-widest font-semibold rounded-full">
            PREMIUM
          </div>
        )}

        {/* Bottom gradient + text overlay */}
        <div className="absolute inset-x-0 bottom-0 pt-16 pb-3 px-3 bg-gradient-to-t from-black/85 via-black/55 to-transparent">
          <div className="text-center text-white card-text-shadow">
            <div className="font-serif text-lg sm:text-xl leading-tight truncate">
              {angel.artistic_name}{angel.age ? `, ${angel.age}` : ""}
            </div>
            <div className="text-xs sm:text-sm text-white/90 truncate mt-0.5">
              {angel.comuna || "—"}
            </div>
          </div>
        </div>

        {/* Heart button */}
        <button
          data-testid={`fav-btn-${angel.angel_id}`}
          onClick={(e) => { e.preventDefault(); onToggleFav && onToggleFav(angel); }}
          className="absolute bottom-2 right-2 h-10 w-10 rounded-full flex items-center justify-center bg-black/35 hover:bg-black/55 backdrop-blur-sm transition"
          aria-label="Favorito"
        >
          <Heart
            size={22}
            strokeWidth={1.8}
            className={favorited ? "fill-[#D4AF37] text-[#D4AF37]" : "text-white"}
          />
        </button>
      </Link>
    </div>
  );
};

export default AngelCard;
